import { render, staticRenderFns } from "./jigou.vue?vue&type=template&id=0d8779d8&scoped=true&"
import script from "./jigou.vue?vue&type=script&lang=js&"
export * from "./jigou.vue?vue&type=script&lang=js&"
import style0 from "./jigou.vue?vue&type=style&index=0&id=0d8779d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8779d8",
  null
  
)

export default component.exports